import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { GridState } from '../reducers/grid.reducer';
import * as selectors from '../selectors/grid.selectors';

@Injectable({
  providedIn: 'root',
})
export class GridFacadeService extends FacadeService {
  constructor(public override store: Store<GridState>) {
    super(store);
  }

  renderGrid$ = this.storeSelect(selectors.getRenderGrid);
  renderNoGridResults$ = this.storeSelect(selectors.getRenderNoGridResults);
  displayedColumns$ = this.storeSelect(selectors.getDisplayedColumns);
  displayedColumnKeys$ = this.storeSelect(selectors.getDisplayedColumnKeys);
  selectedId$ = this.storeSelect(selectors.getSelectedId);
  gridData$ = this.storeSelect(selectors.getGridData);
  selectedRow$ = this.storeSelect(selectors.getSelectedRow);
  showSpinner$ = this.storeSelect(selectors.getShowSpinner);
  newLiteralsData$ = this.storeSelect(selectors.getNewLiteralsData);
  literalsData$ = this.storeSelect(selectors.getLiteralsData);

  get renderGrid() {
    return this.storeSnapshot(this.renderGrid$);
  }

  get selectedId() {
    return this.storeSnapshot(this.selectedId$);
  }

  get gridData() {
    return this.storeSnapshot(this.gridData$);
  }

  get selectedRow() {
    return this.storeSnapshot(this.selectedRow$);
  }

  get newLiteralsData() {
    return this.storeSnapshot(this.newLiteralsData$);
  }

  get literalsData() {
    return this.storeSnapshot(this.literalsData$);
  }
}
